import { render, staticRenderFns } from "./NoWillNotifyStep.vue?vue&type=template&id=76b1aa5a"
import script from "./NoWillNotifyStep.vue?vue&type=script&lang=ts"
export * from "./NoWillNotifyStep.vue?vue&type=script&lang=ts"
import style0 from "./NoWillNotifyStep.vue?vue&type=style&index=0&id=76b1aa5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports